import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UserGroupService {

  constructor(private http: HttpClient) { }

  url = `${environment.url}/user_groups`

  get() {
    return this.http.get(this.url) as Observable<any>;
  }

  // getUser(id: number) {
  //   return this.http.get(`${environment.url}/users/${id}`) as Observable<any>;
  // }

}
